

// es6 polyfill
import 'core-js/fn/array/find-index';
import x_Store from '../xman/store';
import x_Cascader from '../xman/xcascader';
// import x_StoreOrganizationSelect from '../xman/store-organization-select';
// import x_StoreOrganizationCheck from '../xman/store-organization-check';
import x_StoreSearch from '../xman/storeSearch';
import x_SelectTime from '../xman/select-time';
import x_Calendar from '../xman/calendar';
import x_CalendarMarket from './calendar-market';
import x_CalendarSku from './calendar-sku';
import x_CalendarSchedule from './calendar-schedule';
import x_StoreCheck from '../xman/store-check';
import x_StoreSelect from '../xman/store-select';
import x_OrgCheck from '../xman/org-check';
import x_MultiCategory from '../xman/multi-category';
import x_Category from '../xman/category';
import x_CauseChart from '../xman/cause-chart';
import x_IndicatorCard from './indicator-cause/indicator-card'
import x_IndicatorLine from '../xman/indicator-cause/indicator-line'
import x_IndicatorLayout from '../xman/indicator-cause/indicator-layout'
import x_IndicatorOperator from './indicator-cause/indicator-operator'


const popDesignX = {
    x_Store,
    x_Cascader,
    // x_StoreOrganizationSelect,
    // x_StoreOrganizationCheck,
    x_StoreSearch,
    x_SelectTime,
    x_Calendar,
    x_Category,
    x_CalendarMarket,
    x_CalendarSchedule,
    x_CalendarSku,
    x_StoreCheck,
    x_StoreSelect,
    x_OrgCheck,
    x_MultiCategory,
    x_CauseChart,
    x_IndicatorCard,
    x_IndicatorLine,
    x_IndicatorLayout,
    x_IndicatorOperator
};
const install = function (Vue) {
    Object.keys(popDesignX).forEach((key) => {
        if(key!="assist"){
            if(key.indexOf("x_")!=-1){
                Vue.component(key.split("_")[0]+key.split("_")[1], popDesignX[key]);
            }else{
                Vue.component('p'+key, popDesignX[key]);
            }
        }
    });

};

// auto install
if(typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

module.exports = Object.assign(popDesignX, {
    install
});



// WEBPACK FOOTER //
// ./src/xman/index.js